import axios from 'axios'
import { env } from '@/env'
const buildingLinkServerURL = env.VUE_APP_NODE_SERVER_BLK

export const state = {
  allServicesList: null,
  ServicesCategoryList: null,
  addProduct: 1,
  addCheck: 1,
  addServiceInfo: null,
  addProductDetails: [],
  addCheckList: [],
  questionList: [],
  toPost: false,
  checklistAdded: false,
  QuestionListAdded: false,
  ProductListAdded: false,
  serviceId: null,
  adminServiceDetails: [],
  files: [],
  fileLogoImage: [],
  videofiles: [],
  infoById: null,
  // secSelected : [false,false,false,false]
  secSelected: null,
  percentageUpload: 0,
  ServiceRequestFormsStored: {},
}

export const getters = {
  questionList: (state) => {
    return state.questionList
  },
  gettoPost: (state) => {
    return state.toPost
  },
  getaddProduct: (state) => {
    return state.addProduct
  },
  getaddCheck: (state) => {
    return state.addCheck
  },
  getaddProductList: (state) => {
    return state.addProductDetails
  },
  getAdminServiceDetails: (state) => {
    return state.adminServiceDetails
  },
}

export const mutations = {
  SET_ALLSERVICES(state, newValue) {
    state.allServicesList = newValue
  },
  SET_SERVICES_CATEGORY(state, newValue) {
    state.ServicesCategoryList = newValue
  },
  SET_QUESTION_LIST(state, newValue) {
    state.questionList = newValue
  },
  addProducts: (state, payload) => {
    console.log('payload', payload)
    state.addProductDetails = payload
  },
  copyProducts: (state, payload) => {
    console.log('payload', payload)
    // state.addProductDetails.push(payload);
    state.addProductDetails.splice(
      payload + 1,
      0,
      state.addProductDetails[payload]
    )
    console.log(state.addProductDetails)
  },

  addInfo: (state, payload) => {
    console.log(payload)
    state.addServiceInfo = payload

    console.log('state.addServiceInfo', state.addServiceInfo)
  },

  fileArray: (state, payload) => {
    console.log('commit', payload)
    // state.files.splice(0,1,payload);
    let filearray = [payload]
    state.files = filearray
    // state.files.push(payload);
    console.log('state.files', state.files)
  },
  fileLogo: (state, payload) => {
    console.log('commit', payload)
    // state.files.splice(0,1,payload);
    let filearray = [payload]
    state.fileLogoImage = filearray
    // state.files.push(payload);
    console.log('state.fileLogoImage', state.fileLogoImage)
  },
  fileVideoArray: (state, payload) => {
    console.log('commit', payload)
    // state.files.splice(0,1,payload);
    let filearray = [payload]
    state.videofiles = filearray
    // state.files.push(payload);
    console.log('state.files', state.videofiles)
  },

  addCheckListItem: (state, payload) => {
    console.log(payload)
    state.addCheckList = payload
  },

  setQuestionList: (state, payload) => {
    state.questionList = payload
  },
  incrementaddProduct: (state) => {
    state.addProduct += 1
  },
  incrementCheckList: (state) => {
    state.addCheck += 1
  },
  SetToPost: (state) => {
    // state.toPost = true;
    state.toPost = !state.toPost
  },
  setCheckListAdded: (state, payload) => {
    state.checklistAdded = payload
  },
  setQuestionListAdded: (state, payload) => {
    state.QuestionListAdded = payload
  },
  setProductListAdded: (state, payload) => {
    state.ProductListAdded = payload
  },
  setServiceID: (state, payload) => {
    state.serviceId = payload
  },
  SET_BUILDING_SERVICES: (state, payload) => {
    console.log('inside SET_BUILDING_SERVICES ', payload)
    state.adminServiceDetails = payload
    console.log('state.adminServiceDetails ', state.adminServiceDetails)
  },
  SET_SECTION_SELECTED: (state, payload) => {
    // console.log("state.secSelected",state.secSelected)
    // state.secSelected[payload] = !state.secSelected[payload] ;
    console.log('state.secSelected', state.secSelected)
    state.secSelected = payload
    console.log('state.secSelected', state.secSelected)
  },
  SET_SERVICE_INFO_BY_ID: (state, payload) => {
    state.infoById = payload
    console.log('state.infoById', state.infoById)
  },
  CLEAR_FILEARR: (state, payload) => {
    state.files = payload
    state.videofiles = payload
    state.fileLogoImage = payload
    console.log('Clear file', state.files)
    console.log('Clear videofiles', state.videofiles)
  },
  SET_UPLOADPERCENTAGE: (state, payload) => {
    state.percentageUpload = payload
  },
  SET_SERVICE_REQUEST_FORM_RESPONSE: (state, payload) => {
    state.ServiceRequestFormsStored = payload
  },
}

export const actions = {
  // Get order List for Vendor
  async GetOrderListbyVendorID({ commit, state, rootState }, data) {
    try {
      const getServicesDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}GetOrderListbyVendorID?providerId=${
          data.providerId
        }&pageSize=100&skipRecords=${data.recordAvailable}&searchKeyword=${
          data.searchKeyword
        }`,
      })
      return getServicesDetails.data.value
    } catch (error) {
      throw error
    }
  },
  // convert into order
  async VendorConvertToOrderServiceRequest({ commit, state, rootState }, data) {
    try {
      const getServicesDetails = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}VendorConvertToOrderServiceRequest`,
        data: data,
      })
      return getServicesDetails.data.value
    } catch (error) {
      throw error
    }
  },
  // send Payment Request To Resident
  async sendPaymentRequestToResident({ commit, state, rootState }, data) {
    try {
      const getServicesDetails = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ServiceRequestMilestonePayment?serviceRequestId=${
          data.serviceRequestId
        }&milestoneId=${data.milestoneId}`,
      })
      return getServicesDetails.data.value
    } catch (error) {
      throw error
    }
  },
  // -------------------------------------------------------------------------
  async getListOfAllVendorInquiries_BLK({ commit, state, rootState }, data) {
    try {
      const getServicesDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestFormEnquiries?$skip=${
          data.recordAvailable
        }&$filter=ServiceRequestForm/Provider/SandOStatus eq 1 and ServiceRequestForm/Provider/ProviderId eq ${
          data.providerId
        }&$orderby=Id desc&$expand=ServiceRequestForm($expand=Provider($select=ProviderId,ProviderName,ProviderEmail,ProviderPhone))`,
      })

      const responseData = getServicesDetails.data.value
      console.log('responseData', responseData)

      const allVendors = responseData
      return allVendors
    } catch (error) {
      throw error
    }
  },
  async loadSearchedEnquiryForVendor_BLK({ commit, state, rootState }, data) {
    try {
      const getServicesDetails = await axios({
        method: 'get',

        url: `${buildingLinkServerURL}ServiceRequestFormEnquiries?$skip=${
          data.recordAvailable
        }&$filter=(contains( Message ,'${data.searchValue}') or
          contains(Name,'${data.searchValue}' ) or
          contains(Phone,'${data.searchValue}' )or
           contains(ServiceRequestForm/ServiceRequestFormName,'${
             data.searchValue
           }' )or
           contains(ServiceRequestForm/Provider/ProviderName,'${
             data.searchValue
           }' )) and
           ServiceRequestForm/Provider/SandOStatus eq 1
           and ServiceRequestForm/Provider/ProviderId eq ${data.providerId}
        &$orderby=Id desc&$expand=ServiceRequestForm($expand=Provider ($select=ProviderName,ProviderEmail,ProviderPhone))`,
      })
      const responseData = getServicesDetails.data.value
      const allVendors = responseData
      return allVendors
    } catch (error) {
      throw error
    }
  },

  async searchingRequestFromSandoDatabaseById(
    { commit, state, rootState },
    data
  ) {
    try {
      let getServices

      getServices = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequests?$filter=ServiceRequestId eq ${
          data.requestName
        } &$expand=ServiceRequestForm($expand=ServiceRequestFormCategory),
        ServiceRequestStatus,ServiceRequestForm($expand=ServiceRequestFormCategory),
        ServiceRequestFormOptionDatas($expand=ServiceRequestFormOption)&$orderby=ServiceRequestId desc`,
      })

      return getServices
    } catch (error) {
      throw error
    }
  },
  async searchingRequestFromSandoDatabase({ commit, state, rootState }, data) {
    try {
      let getServices = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequests?$skip=${
          data.recordAvailable
        }&$filter=(ServiceRequestForm/Provider/SandOStatus eq 1 and ServiceRequestForm/Provider/ProviderId eq ${
          data.providerId
        }) and  contains(ServiceRequestForm/ServiceRequestFormName,'${
          data.requestName
        }') and ServiceRequestIsWaitingForProvider eq ${
          data.archieved
        } &$expand=ServiceRequestForm($expand=ServiceRequestFormCategory),ServiceRequestStatus,`,
      })

      return getServices
    } catch (error) {
      throw error
    }
  },
  async getServiceRequestDetailsByID_BLK({ commit, state, rootState }, data) {
    try {
      const requestService = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequests(${
          data.Id
        })?$expand=ServiceRequestForm,ServiceRequestFormPromptDatas($expand=ServiceRequestFormPromptDataPrompt($expand=ServiceRequestFormPromptChoices)),ServiceRequestFormOptionDatas($expand=ServiceRequestFormOption),ServiceRequestStatus,`,
      })

      let requestDetails = requestService.data
      console.log(
        'getServiceRequestDetailsByID_BLK -> requestDetails',
        requestDetails
      )
      return requestDetails
    } catch (error) {
      throw error
    }
  },
  async getAllServicesRequestedByResidentForVendor_Blk(
    { commit, state, rootState },
    data
  ) {
    try {
      const getServices = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequests?$skip=${
          data.recordAvailable
        }&$filter=ServiceRequestIsWaitingForProvider eq ${
          data.archieved
        } and  ServiceRequestForm/Provider/SandOStatus eq 1 and ServiceRequestForm/Provider/ProviderId eq ${
          data.providerId
        }&$expand=ServiceRequestForm($expand=ServiceRequestFormCategory),ServiceRequestStatus,ServiceRequestFormOptionDatas($expand=ServiceRequestFormOption)&$orderby=ServiceRequestId desc`,
      })
      return getServices
    } catch (error) {
      throw error
    }
  },
  async getActiveServicesCount_Blk({ commit, state, rootState }, data) {
    try {
      const getServices = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequests?$count=true&$filter=ServiceRequestForm/Provider/SandOStatus eq 1 and ServiceRequestForm/Provider/ProviderId eq ${
          data.providerId
        } and ServiceRequestIsWaitingForProvider eq true`,
      })
      return getServices
    } catch (error) {
      throw error
    }
  },
  async PatchPayementServicesRequestedByResidentForVendor_Blk(
    { commit, state, rootState },
    data
  ) {
    try {
      const getServices = await axios({
        method: 'patch',
        url: `${buildingLinkServerURL}ServiceRequests(${data.Id})`,
        data: data.data,
      })
      return getServices
    } catch (error) {
      throw error
    }
  },
  async addVendorNoteForResident_BLK({ commit, state, rootState }, data) {
    try {
      const getServices = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ServiceRequestNotes`,
        data: data.data,
      })
      return getServices
    } catch (error) {
      throw error
    }
  },
  async PatchServicesRequestedByResidentForVendor_Blk(
    { commit, state, rootState },
    data
  ) {
    try {
      const getServices = await axios({
        method: 'patch',
        url: `${buildingLinkServerURL}ServiceRequests(${data.Id})`,
        data: data.data,
      })
      return getServices
    } catch (error) {
      throw error
    }
  },

  async deleteParticularService_BLK({ commit, state, rootState }, data) {
    console.log('In deleteParticularService_BLK', data)
    try {
      const getServices = await axios({
        method: 'delete',
        url: `${buildingLinkServerURL}ServiceRequestForms(${
          data.ServiceFormID
        })`,
      })

      const responseData = getServices
      return responseData
    } catch (error) {
      console.log('TCL: Delete particular service by ID -> error', error)
      throw error
    }
  },

  async getAllServicesfunction_BLK({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceFormByProviderIdAsync(searchKeyword='${
          data.serviceName
        }',providerId=${data.providerId},providerStatus=${
          data.providerStatus
        },sortingBy='${data.sorting}',pageSize=100,skipRecords=${
          data.recordAvailable
        })`,
      })

      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },
  async getServiceDistributionCount_BLK({ commit, state, rootState }, data) {
    try {
      let getServiceCount = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms?$filter=Provider/SandOStatus eq 1 and ServiceRequestFormId eq ${
          data.serviceFormID
        }&$count=true &$select=ServiceRequestFormId&$expand=ServiceRequestFormFacilityLinks($count=true)`,
      })

      return getServiceCount
    } catch (error) {
      console.log('TCL: getAllServices -> error', error)
      throw error
    }
  },
  async getAllServiceForSequenceOrder_BLK({ commit, state, rootState }, data) {
    try {
      const getServices = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms?$skip=${
          data.recordAvailable
        }&$filter=Provider/SandOStatus eq 1&$orderby=SequenceNumber&$select=ServiceRequestFormId,ServiceRequestFormName`,
      })
      return getServices
    } catch (error) {
      throw error
    }
  },
  async loadSearchServices_BLK({ commit, state, rootState }, data) {
    try {
      const getServices = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms?$skip=${
          data.recordAvailable
        }&$filter=( contains( ServiceRequestFormName,'${
          data.serviceName
        }') or contains( Provider/ProviderName,'${
          data.serviceName
        }')  or contains( ServiceRequestFormCategory/ServiceRequestFormCategoryText
        ,'${
          data.serviceName
        }')  ) and Provider/SandOStatus eq 1 & &$orderby=ServiceRequestFormCreateDate desc &$select=ServiceRequestFormId,ServiceRequestFormProviderId,ServiceRequestFormName,ServiceRequestFormCreateDate&$expand=ServiceRequestFormEnquiries($count=true),ServiceRequestFormCategory,ServiceRequestFormFacilityLinks($count=true),ServiceRequestFormOptions,ServiceRequestFormsImages($select=Id),Provider($select=ProviderName),ServiceRequestFormEnquiries($select=Id),ServiceRequestFormPrompts($expand=ServiceRequestFormPromptChoices)`,
      })
      const responseData = getServices.data.value
      console.log('responseData', responseData)
      // if (!responseData.length) {
      //   throw new Error('Invalid data received')
      // }
      console.log('TCL: getAllservices -> responseData', responseData)
      const serviceList = responseData
      return serviceList
    } catch (error) {
      console.log('TCL: getAllServices -> error', error)
      throw error
    }
  },

  async getAllServicesCategory_BLK({ commit, state, rootState }) {
    console.log('in getAllServicesCategory_BLK')
    try {
      const getServicesCategory = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}/ServiceRequestFormCategories?$orderby=ServiceRequestFormCategoryText`,
      })
      const responseData = getServicesCategory.data.value
      console.log(
        'TCL: getAllServicesCategory_BLK -> responseData',
        responseData
      )
      // if (!responseData.length) {
      //   throw new Error('Invalid data received')
      // }
      return responseData
    } catch (error) {
      console.log('TCL: getAllServicesCategory_BLK -> error', error)
      throw error
    }
  },
  async postAllServices_BLK({ commit, state, rootState }, data) {
    console.log('IN postAllServices_BLK')
    console.log('data', data)

    try {
      const postServices = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ServiceRequestForms`,
        data: data,
        onUploadProgress: (progressEvent) => {
          var Percentage = parseInt(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          )

          commit('SET_UPLOADPERCENTAGE', Percentage)
        },
      })
      const responseData = postServices
      console.log('postAllServices_BLK -> responseData', responseData)
      console.log('responseData status', responseData)
      commit('CLEAR_FILEARR', [])
      return responseData
    } catch (error) {
      console.log('TCL: postServices -> error', error)
      throw error
    }
  },
  async patchAllServices_BLK({ commit, state, rootState }, data) {
    console.log('IN patchAllServices_BLK')
    console.log('data', data)

    try {
      const postServices = await axios({
        method: 'patch',
        url: `${buildingLinkServerURL}ServiceRequestForms(${data.id})`,
        data: data.data,
        onUploadProgress: (progressEvent) => {
          var Percentage = parseInt(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          )

          commit('SET_UPLOADPERCENTAGE', Percentage)
        },
      })
      const responseData = postServices
      console.log('postAllServices_BLK -> responseData', responseData)
      console.log('responseData status', responseData)
      commit('CLEAR_FILEARR', [])
      return responseData
    } catch (error) {
      console.log('TCL: postServices -> error', error)
      throw error
    }
  },
  async deleteImagesFromService_BLK({ commit, state, rootState }, data) {
    try {
      var deleteresponse = await axios({
        method: 'delete',
        url: `${buildingLinkServerURL}ServiceRequestFormsImages(${data.Id})`,
      })
      const responseData = deleteresponse
      return responseData
    } catch (error) {
      console.log('TCL: deleteImagesFromService_BLK', error)
      throw error
    }
  },
  async deleteChoiceFromServiceQuestions_BLK(
    { commit, state, rootState },
    data
  ) {
    try {
      var deleteresponse = await axios({
        method: 'delete',
        url: `${buildingLinkServerURL}ServiceRequestFormPromptChoices(${
          data.Id
        })`,
      })
      const responseData = deleteresponse
      return responseData
    } catch (error) {
      console.log('TCL: deleteChoiceFromServiceQuestions_BLK', error)
      throw error
    }
  },
  async deleteQuestionFromServiceQuestions_BLK(
    { commit, state, rootState },
    data
  ) {
    try {
      var deleteresponse = await axios({
        method: 'delete',
        url: `${buildingLinkServerURL}ServiceRequestFormPrompts(${data.Id})`,
      })
      const responseData = deleteresponse
      return responseData
    } catch (error) {
      console.log('TCL: deleteQuestionFromServiceQuestions_BLK', error)
      throw error
    }
  },
  async deleteProductFromServiceProducts_BLK(
    { commit, state, rootState },
    data
  ) {
    try {
      var deleteresponse = await axios({
        method: 'delete',
        url: `${buildingLinkServerURL}ServiceRequestFormOptions(${data.Id})`,
      })
      const responseData = deleteresponse
      return responseData
    } catch (error) {
      console.log('TCL: deleteProductFromServiceProducts_BLK', error)
      throw error
    }
  },
  async deleteBuildingLinkingFromTable_BLK({ commit, state, rootState }, data) {
    try {
      var deleteresponse = await axios({
        method: 'delete',
        url: `${buildingLinkServerURL}ServiceRequestFormFacilityLinks(${
          data.Id
        })`,
      })
      const responseData = deleteresponse
      return responseData
    } catch (error) {
      console.log('TCL: deleteBuildingLinkingFromTable_BLK', error)
      throw error
    }
  },
  async addImagestoService_BLK({ commit, state, rootState }, data) {
    try {
      var addResponse = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ServiceRequestFormsImages`,
        data: data,
      })
      const responseData = addResponse
      return responseData
    } catch (error) {
      console.log('TCL: addImagestoService_BLK', error)
      throw error
    }
  },
  async addQuestionToServiceQuestions_BLK({ commit, state, rootState }, data) {
    try {
      var addResponse = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ServiceRequestFormPrompts`,
        data: data,
      })
      const responseData = addResponse
      return responseData
    } catch (error) {
      console.log('TCL: addQuestionToServiceQuestions_BLK', error)
      throw error
    }
  },
  async addProductToServiceProducts_BLK({ commit, state, rootState }, data) {
    try {
      var addResponse = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ServiceRequestFormOptions`,
        data: data,
      })
      const responseData = addResponse
      return responseData
    } catch (error) {
      console.log('TCL: addProductToServiceProducts_BLK', error)
      throw error
    }
  },
  clearFileArray({ commit, state, rootState }) {
    commit('CLEAR_FILEARR', [])
  },

  async getServiceDetailsByID_BLK({ commit, state, rootState }, data) {
    console.log('in getServiceDetailsByID_BLK', data)
    try {
      const getServices = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms(ServiceRequestFormId=${
          data.Id
        })?$expand=ServiceRequestFormsImages,ServiceRequestFormOptions,ServiceRequestFormPrompts($expand=ServiceRequestFormPromptChoices),Provider($select=ProviderName)`,
      })
      const responseData = getServices.data
      commit('SET_SERVICE_REQUEST_FORM_RESPONSE', responseData)
      return responseData
    } catch (error) {
      console.log('TCL: getServiceDetailsByID_BLK -> error', error)
      throw error
    }
  },

  addAllQuestions({ commit, state, rootState }, Qobject) {
    console.log(Qobject)
    commit('SET_QUESTION_LIST', Qobject)
  },
  addInfo({ commit }, payload) {
    console.log('addInfo -> payload', payload)
    commit('addInfo', payload)
  },
  addProducts: ({ commit }, payload) => {
    console.log('ADDING PRODUCT', payload)
    commit('addProducts', payload)
  },
  copyProducts: ({ commit }, payload) => {
    console.log(payload)
    commit('copyProducts', payload)
  },

  addCheckListItem: ({ commit }, payload) => {
    console.log(payload)
    commit('addCheckListItem', payload)
  },

  fileArray: ({ commit }, payload) => {
    commit('fileArray', payload)
  },
  fileLogo: ({ commit }, payload) => {
    commit('fileLogo', payload)
  },
  fileVideoArray: ({ commit }, payload) => {
    commit('fileVideoArray', payload)
  },
  appendInfo: ({ commit }, key, payload) => {
    commit('appendInfo', key, payload)
  },

  setQuestionList: ({ commit }, payload) => {
    commit('setQuestionList', payload)
  },
  incrementaddProduct: ({ commit }) => {
    commit('incrementaddProduct')
  },
  incrementCheckList: ({ commit }) => {
    commit('incrementCheckList')
  },
  SetToPost: ({ commit }) => {
    console.log('commit')
    commit('SetToPost')
  },
  setCheckListAdded: ({ commit }, payload) => {
    console.log('commit')
    commit('setCheckListAdded', payload)
  },
  setQuestionListAdded: ({ commit }, payload) => {
    console.log('commit')
    commit('setQuestionListAdded', payload)
  },
  setProductListAdded: ({ commit }, payload) => {
    console.log('commit setProductListAdded')
    commit('setProductListAdded', payload)
  },
  setServiceID: ({ commit }, payload) => {
    console.log('commit')
    commit('setServiceID', payload)
  },
  SET_SECTION_SELECTED: ({ commit }, payload) => {
    console.log('commit')
    commit('SET_SECTION_SELECTED', payload)
  },

  async signupProviderBLK({ commit, state, rootState }, data) {
    console.log('in signupProviderBLK')
    try {
      const getStatus = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}Providers`,
        data,
        headers: {
          auth: `${rootState.auth.authToken}`,
        },
      })
      const responseData = getStatus

      return responseData
    } catch (error) {
      console.log('TCL: signupProviderBLK -> error', error)
      throw error
    }
  },

  async editProviderBLK({ commit, state, rootState }, data) {
    console.log('in EditProviderBLK', data)
    try {
      const getStatus = await axios({
        method: 'patch',
        url: `${buildingLinkServerURL}/Providers(${data.id})`,
        data: data.data,
        headers: {
          auth: `${rootState.auth.authToken}`,
        },
      })
      const responseData = getStatus
      return responseData
    } catch (error) {
      console.log('TCL: EditProviderBLK -> error', error)
      throw error
    }
  },
  async UserCreateProvider({ commit, state, rootState }, data) {
    try {
      const getStatus = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}CreateUserProvider`,
        data: data,
      })
      const responseData = getStatus
      return responseData
    } catch (error) {
      console.log('TCL: ProviderCompanyCreate -> error', error)
      throw error
    }
  },
  async createCompanyProvider({ commit, state, rootState }, data) {
    try {
      const getStatus = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ProviderCompanyCreate`,
        data: data,
      })
      const responseData = getStatus
      return responseData
    } catch (error) {
      console.log('TCL: ProviderCompanyCreate -> error', error)
      throw error
    }
  },
  async sendEmailNotificationToUser({ commit, state, rootState }, data) {
    try {
      const getStatus = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}UserInviteResend`,
        data: data,
      })
      const responseData = getStatus
      return responseData
    } catch (error) {
      console.log('TCL: UserInviteResend -> error', error)
      throw error
    }
  },
  async VendorPayoutAndOrderAnalysisReportAsync(
    { commit, state, rootState },
    data
  ) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}VendorPayoutAndOrderAnalysisReportAsync?searchKeyword=${
          data.searchKeyword
        }&pageSize=100&skipRecords=${data.recordAvailable}`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      console.log('TCL: UserInviteResend -> error', error)
      throw error
    }
  },
  async OrderAnalysisReportAsync({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}OrderAnalysisReportAsync?searchKeyword=${
          data.searchKeyword
        }&pageSize=100&skipRecords=${data.recordAvailable}`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      console.log('TCL: UserInviteResend -> error', error)
      throw error
    }
  },
  async SandOEarningReportAsync({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}SandOEarningReportAsync?searchKeyword=${
          data.searchKeyword
        }&pageSize=100&skipRecords=${data.recordAvailable}`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      console.log('TCL: UserInviteResend -> error', error)
      throw error
    }
  },

  clear_Upload_Percentage({ commit, state, rootState }) {
    commit('SET_UPLOADPERCENTAGE', 0)
  },
}
